import net, { IRequestOptions, IRequestOptionsWithPass } from '@/services/net'
import { PackEntityAppSmsOverviewVO } from '../Type/PackEntityAppSmsOverviewVO'

interface DataModel {
	aid?: string
	cid?: string
}

/**
 *	查询短信功能总览
 * @param {DataModel} [data] 封装对象
 * @param {string} [data.aid] 应用id
 * @param {string} [data.cid] 企业id
 */

export function funcsmsoverview(data: DataModel, options: IRequestOptionsWithPass): Promise<PackEntityAppSmsOverviewVO>
export function funcsmsoverview(
	data: DataModel,
	options?: IRequestOptions,
): Promise<PackEntityAppSmsOverviewVO extends { msg: unknown } ? PackEntityAppSmsOverviewVO['msg'] : undefined>
export function funcsmsoverview(data: DataModel, options: IRequestOptionsWithPass | IRequestOptions = {}) {
	const { aid, cid } = data
	return net('/frontApi/app/func/sms/overview', {
		method: 'post',
		params: {
			aid,
			cid,
		},

		...(options || {}),
	})
}
